module.exports = __webpack_public_path__ + "img/1.acf5072f.png";